import {LoginPage} from "./Login";

const auth = {
  LoginPage
}

export default auth